<template>
  <div class="simple-editor">
    <div class="editor-toolbar">
      <div class="toolbar-left">
        <button
          type="button"
          :class="['toolbar-btn', { active: !showSource }]"
          @click="showSource = false">
          Visual
        </button>
        <button
          type="button"
          :class="['toolbar-btn', { active: showSource }]"
          @click="showSource = true">
          Source
        </button>
      </div>
    </div>

    <div v-show="!showSource" class="visual-editor">
      <editor
        :value="value"
        @input="handleInput"
        :editor-toolbar="customToolbar"
        :editor-options="editorOptions" />
    </div>

    <div v-show="showSource" class="source-editor">
      <textarea
        :value="value"
        @input="handleSourceInput"
        :disabled="disabled"
        class="source-textarea"
        spellcheck="false" />
    </div>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'

export default {
  components: {
    Editor: VueEditor,
  },

  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      showSource: false,
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['clean'],
      ],
      editorOptions: {
        modules: {
          toolbar: this.customToolbar,
        },
      },
    }
  },

  methods: {
    handleInput (value) {
      this.$emit('input', value)
    },
    handleSourceInput (event) {
      this.$emit('input', event.target.value)
    },
  },
}
</script>

<style scoped>
.simple-editor {
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
}

.editor-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid #ddd;
  background-color: #f9fafb;
  border-radius: 4px 4px 0 0;
}

.toolbar-left {
  display: flex;
  gap: 4px;
}

.toolbar-btn {
  padding: 6px 12px;
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: #666;
  transition: all 0.2s;
}

.toolbar-btn:hover {
  background: #f3f4f6;
  border-color: #bbb;
}

.toolbar-btn.active {
  background: #3b82f6;
  border-color: #3b82f6;
  color: #fff;
}

.visual-editor {
  border-top: none;
}

.source-editor {
  border-top: none;
}

.source-textarea {
  width: 100%;
  min-height: 200px;
  padding: 16px;
  border: none;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 13px;
  line-height: 1.5;
  color: #333;
  background: #fafafa;
  resize: vertical;
}

.source-textarea:focus {
  outline: none;
  background: #fff;
}

.source-textarea:disabled {
  background: #f9fafb;
  color: #999;
  cursor: not-allowed;
}

.simple-editor >>> .ql-container {
  min-height: 200px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
}

.simple-editor >>> .ql-toolbar {
  border: none;
  background: transparent;
}

.simple-editor >>> .ql-container {
  border: none;
  border-radius: 0 0 4px 4px;
}
</style>
